import { Pressable, StyleSheet, View } from "react-native";
import { tokens } from "components/tokens";
import { Text } from "components/text_v2";

interface ReportingBudgetWarningProps {
  onClick: () => void;
}

export function ReportingBudgetWarningDesktop(
  props: ReportingBudgetWarningProps,
) {
  const { onClick } = props;

  return (
    <View style={styles.container}>
      <Text testID="monthly-budget-warning" color="white-core" weight="bold">
        You’ve almost hit your monthly budget.
      </Text>
      <Pressable
        onPress={onClick}
        style={({ hovered, pressed }: any) => [
          styles.button,
          (hovered || pressed) && styles.buttonHoveredPressed,
        ]}
      >
        {() => (
          <Text size="xs" color="grapefruit-core">
            Increase Budget
          </Text>
        )}
      </Pressable>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 24,
    backgroundColor: tokens.colors.secondary.regular,
    borderRadius: 6,
    color: "white",
    ...tokens.shadow.elevation1,
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
  },
  button: {
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "rgba(245, 246, 247, 1)",
    height: 42,
    maxHeight: 42,
    paddingLeft: 8,
    paddingRight: 8,
    borderRadius: 4,
  },
  buttonHoveredPressed: {
    backgroundColor: "rgba(218, 222, 229, 1)",
  },
});
